export default __webpack_public_path__ + "static/media/6-multiRound.f5174ee9.jpg";